
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rankings/[...slug]",
      function () {
        return require("private-next-pages/rankings/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rankings/[...slug]"])
      });
    }
  